export { default } from './DetailComponent'
